module.exports = __webpack_public_path__ + "static/media/lista.c85fd857.svg";